import { GET_INVENTORY, UPDATE_INVENTORY } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const fetchInventoryDataByNetwork = async (network) => {
  try {
    const resp = await apiClient.get(GET_INVENTORY(network), {});
    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};

export const updateInventoryRecord = async (id, data, network) => {
  try {
    const resp = await apiClient.put(UPDATE_INVENTORY(id, network), data);
    return resp.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
